import "../../css/home1.css";

function HomeSection1() {
  return (
    <section className="section1" id="section1">
      {/* Sliding Gradient Background Elements */}
      <div className="bg"></div>
      <div className="bg bg2"></div>
      <div className="bg bg3"></div>

      {/* Content Container - Perfect centering */}
      <div className="container h-100 ctn-delay">
        <div className="row h-100 align-items-center justify-content-center">
          {/* Logo Column */}
          <div className="col-lg-6 d-flex justify-content-center align-items-center p-4">
            <img
              src={require(`../../img/voilaLogoLetras.png`)}
              alt="Logo empresa"
              className="img-fluid mw-100 logosection1"
            />
          </div>

          {/* Content Column */}
          <div className="col-lg-6 d-flex flex-column justify-content-center p-4">
            <div className="text-center text-lg-start mb-4">
              <h1 className="display-4 fw-bold text-section1">¡Trabajemos juntos!</h1>
            </div>

            <div className="text-center text-lg-start mb-4">
              <p className="lead text-section1">
                Somos una consultoría especializada en la implementación de soluciones estratégicas.
              </p>
            </div>

            <div className="text-center text-lg-start">
              <button className='btn btn-services px-5 py-3'>
                Ver todos los Servicios
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeSection1;